import { PortableText, PortableTextProps } from '@portabletext/react'
import { MlCtaBar, MlCtaBarProps } from '../../molecules'
import { cn } from '../../utils'
import { Media, OrMedia } from '../or-media'

export interface OrContentBlockDProps {
  title: string
  content: string | PortableTextProps['value']
  media?: Media[]
  ctaBar?: MlCtaBarProps
}

export const OrContentBlockD = ({ title, content, media, ctaBar }: OrContentBlockDProps) => {
  const isCtabarVariation = ctaBar !== undefined
  const mediaProps = media?.[0] ? media[0] : null

  return (
    <section className="lg:max-w-screen-lg mx-auto pr-4 py-8 sm:pr-8 slg:px-0">
      <div className="flex flex-col gap-8 slg:flex-row slg:gap-7.5 slg:pr-12 lg:pr-0">
        <div
          className={cn(
            'slg:w-[50%] flex flex-col justify-center gap-4 slg:gap-6 lg:pr-0',
            isCtabarVariation && 'lg:py-8'
          )}
        >
          <div>
            <h2 className="font-heading text-neutrals-900 font-medium text-24 leading-[1.95rem] slg:text-32 slg:leading-1.2">
              {title}
            </h2>
          </div>
          <div>
            {typeof content === 'string' ? (
              <p className="font-regular text-neutrals-700 text-16">{content}</p>
            ) : (
              <PortableText
                value={content}
                components={{
                  block: {
                    normal: ({ children }) => <p className="font-regular text-neutrals-700 text-16">{children}</p>,
                  },
                }}
              />
            )}
          </div>
          {isCtabarVariation && (
            <MlCtaBar
              {...ctaBar}
              primaryClassName="!h-[4.75rem]"
              secondaryClassName="!h-[4.75rem]"
              className="!gap-4 hidden slg:flex"
            />
          )}
        </div>
        {isCtabarVariation ? (
          <div className={mediaProps?.type === 'image' ? 'w-[50%] mx-auto' : 'slg:w-[50%] relative'}>
            <div className="w-full sm:w-full slg:w-[calc(100%+3rem)] lg:w-[calc(100%+10.438rem)] relative lg:w-full h-auto">
              {mediaProps && (
                <OrMedia
                  {...mediaProps}
                  className={`rounded-l-4 slg:rounded-0 slg:!object-contain ${
                    mediaProps.type === 'model3d' ? '!h-90' : ''
                  }`}
                />
              )}
            </div>
          </div>
        ) : (
          <div className="slg:w-[50%] relative">
            <div className="w-full sm:w-full slg:w-[calc(100%+3rem)] lg:w-[calc(100%+10.438rem)] relative lg:w-full h-auto">
              {mediaProps && (
                <OrMedia
                  {...mediaProps}
                  className={`rounded-l-4 slg:rounded-0 ${mediaProps.type === 'model3d' ? '!h-90' : ''}`}
                />
              )}
            </div>
          </div>
        )}
        {isCtabarVariation && (
          <MlCtaBar
            {...ctaBar}
            primaryClassName="!h-[4.75rem]"
            secondaryClassName="!h-[4.75rem]"
            className="!gap-4 slg:hidden"
          />
        )}
      </div>
    </section>
  )
}
